import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Segment, Table, Icon, Grid } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { apiTexto } from "../../../api/texto";
import { ENTORNO } from "../../../utils/constantes";
import { getrole, setTitulo } from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import HomeIcon from "@mui/icons-material/Home";
import { CSVLink } from "react-csv";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";

const apitexto = new apiTexto();

const Componente = ({ textoRegistros }) => {
  const headers = [
    { label: "Tipo", key: "Tipo" },
    { label: "Idioma", key: "Idioma" },
    { label: "Activo", key: "Activo" },
  ];
  const csvData = textoRegistros.map((fila) => [
    fila.Tipo,
    fila.Idioma,
    fila.Activo ? "Si" : "No",
  ]);
  return (
    <CSVLink
      data={csvData}
      headers={headers}
      filename={"textos.csv"}
      className="MuiButtonBase-root MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-default MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-default css-mm42gz-MuiButtonBase-root-MuiFab-root"
      target="_blank"
    >
      {" "}
      <i
        className="file text icon"
        style={{
          fontSize: "large",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
        title="Exportar a Excel"
      ></i>
    </CSVLink>
  );
};

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function TextoConsulta(props) {
  setTitulo("Textos");

  const navigate = useNavigate();

  const navigateToTextoRegistro_Editar = (fila) => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/TextoRegistro", {
      state: {
        id: fila.id,
        tipo: fila.Tipo,
        idioma: fila.Idioma,
        texto: fila.Texto,
        activo: fila.Activo,
        accion: "editar",
      },
    });
  };

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  ////////////////////////////////

  const [textos, setTexto1] = useState(null);
  const [yaCargo, setyaCargo] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        if (!yaCargo) {
          const response = await apitexto.obtenerTodos();
          setyaCargo(true);
          setTexto1(response);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  var textoRegistros = [];

  if (textos) {
    for (let i = 0; i < textos.length; i++) {
      textoRegistros.push({
        id: textos[i]._id,
        Tipo: textos[i].Tipo,
        Idioma: textos[i].Idioma,
        Texto: textos[i].Texto,
        Activo: textos[i].Activo,
      });
    }
  }

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <React.Fragment>
        <CssBaseline />
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Textos varios - Consulta
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        <Container>
          <Box sx={{ my: 2 }}>
            <Segment style={estiloSegmento.Administrador}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <div>
                  <Grid.Row style={{ width: "100%" }}>
                    <Grid.Column style={{ width: "100%" }}>
                      <Segment style={estiloSegmento.Administrador}>
                        <Table compact celled id="tablaTextos">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell textAlign="center">
                                Tipo
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Idioma
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Activo
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center"></Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body id="tablaTextos">
                            {textoRegistros.map((fila, key) => (
                              <Table.Row key={key}>
                                <Table.Cell textAlign="center">
                                  {fila.Tipo}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.Idioma}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.Activo === true ? "Si" : "No"}
                                </Table.Cell>
                                <Table.HeaderCell textAlign="center">
                                  <div
                                    as="a"
                                    onClick={() => {
                                      navigateToTextoRegistro_Editar(fila);
                                    }}
                                  >
                                    <Icon name="pencil" title="Editar" />
                                  </div>
                                </Table.HeaderCell>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Grid>
            </Segment>
          </Box>
          <Box
            sx={{
              position: "fixed",
              bottom: 10,
              right: 10,
              "& > :not(style)": { m: 1 },
            }}
          >
            <Fab
              style={{
                background: "#153B5E",
                color: "white",
                display: "none",
              }}
              aria-label="add"
            ></Fab>
            {/* <ReactHTMLTableToExcel
              id="botonExportar"
              className="MuiButtonBase-root MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-default MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-default css-mm42gz-MuiButtonBase-root-MuiFab-root"
              table="tablaTextos"
              filename="Textos"
              sheet="Página 1"
              buttonText={
                <div>
                  <i
                    className="file excel icon"
                    style={{
                      fontSize: "large",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      width: "100%",
                    }}
                    title="Exportar a Excel"
                  ></i>
                </div>
              }
            />
            <Componente textoRegistros={textoRegistros}></Componente> */}
          </Box>
        </Container>
        <ScrollTop {...props}>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </React.Fragment>
    </div>
  );
}
